module.exports = __webpack_public_path__ + "static/media/messenger.dec07bec.png";